import { selectorActiveNotifications } from "./selectorActiveNotifications";

import {
  NotificationHandleType,
  WSNotificationResponse
} from "../components/Notifications";
import { IdentityVerificationRequestContractorContext } from "../components/Notifications/templates/IdentityVerificationRequestContractor";

export const selectorIdentityVerificationRequestContractorNotifications = (
  responses: WSNotificationResponse[]
) => {
  return selectorActiveNotifications(responses).filter(response => {
    return (
      response.handle ===
      NotificationHandleType.IdentityVerificationRequestContractor
    );
  }) as Array<
    WSNotificationResponse<IdentityVerificationRequestContractorContext>
  >;
};
